import { createRouter, createWebHistory } from "vue-router";
import LoginUser from "../components/LoginUser.vue";
import DataList from "../components/DataList.vue";
import ScrapedDataList from "../components/ScrapedDataList.vue";
import KaiyuanDataList from "../components/KaiyuanDataList.vue";
import MainLayout from "../components/MainLayout.vue";
import VectorStore from "@/components/VectorStore.vue";
import ChatPage from '../components/ChatPage.vue'
import VectorAgent from "@/components/VectorAgent.vue";
import McpAgent from "@/components/McpAgent.vue";
import BigScreenDisplay from '@/components/BigScreenDisplay.vue'

const routes = [
  { 
    path: "/login", 
    name: "Login", 
    component: LoginUser,
    meta:{
      title:"智能数据系统平台"
    },
  },
  {
    path: '/bigscreen',
    name: 'BigScreen',
    component: BigScreenDisplay,
    meta: { title: '大屏展示' },
  },
  {
    path: '/',
    component: MainLayout, // 包含侧边栏的布局
    children: [
      {
        path: '',
        redirect: '/data-list'
      },
      {
        path: '/data-list',
        name: 'DataList',
        component: DataList
      },
      {
        path: '/scraped-data',
        name: 'ScrapedDataList',
        component: ScrapedDataList,
      },
      {
        path: '/kaiyuan-data',
        name: 'KaiyuanDataList',
        component: KaiyuanDataList,
      },
      {
        path: '/vector',
        name: 'VectorStore',
        component: VectorStore,
      },
      {
        path: '/vector-agent',
        name: 'VectorAgent',
        component: VectorAgent,
      },
      {
        path: '/mcp-agent',
        name: 'McpAgent',
        component: McpAgent,
      },
      {
        path: '/chat',
        name: 'Chat',
        component: ChatPage
      },
      {
        path: '/ollama-model',
        component: () => import('@/components/OllamaModel.vue')
      }
    ],    
    meta:{
      title:"智能数据系统平台"
    },
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// **导航守卫，检查登录状态**
router.beforeEach((to, from, next) => {
  const isLoggedIn = localStorage.getItem("token");
  if (to.meta.title) { // 判断是否有标题
    document.title = to.meta.title;
  }
  const publicPages = ['/login', '/bigscreen'];
  if (!publicPages.includes(to.path) && !isLoggedIn) {
    next('/login');
  } else {
    next();
  }
  
  // if (to.path !== "/login" && !isLoggedIn) {
  //   next("/login"); // 未登录，跳转到登录页面
  // } else {
  //   next();
  // }
});

// router.beforeEach((to, from, next) => {
//   const isAuthenticated = localStorage.getItem('token')
//   const publicPages = ['/login']
  
//   if (!publicPages.includes(to.path) && !isAuthenticated) {
//     return next('/login')
//   }
  
//   if (to.path === '/login' && isAuthenticated) {
//     return next('/data-list')
//   }
  
//   next()
// })

export default router;
